import type { ReactNode } from 'react';

export const symbol_curtains: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M160-180v-600q0-24.75 17.63-42.38Q195.25-840 220-840h520q24.75 0 42.38 17.62Q800-804.75 800-780v600h50q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-180 110-180h50Zm60 0h168q-8-74-49-148t-119-95v243Zm0-600v244q78-21 118.5-95.5T387-780H220Zm22 300q94 29 146.5 117.5T449-180h62q8-94 60-182.5T717-480q-94-29-146-117.5T511-780h-63q-8 94-60 182.5T242-480Zm498-300H572q8 74 49 148.5T740-536v-244Zm0 600v-244q-78 21-119 95.5T572-180h168ZM220-780v244-244Zm520 0v244-244Zm0 600v-244 244Zm-520 0v-243 243Z"
		/>
	</svg>
);
